export const basePageMixin = {
  data () {
    return {
      axiosConfig: {
        timeout: 30000
      }
    }
  },
  created: function () {

  },
  methods: {
    testMixin: function (val) {
      console.log(`testMixin: ${JSON.stringify(val)}`)
      self.$root.$emit('toggleloader', false)
    },
    toggleloader: function (val) {
      let self = this
      self.$root.$emit('toggleloader', val)
    },
    showNotification: function (message) {
      let self = this
      self.$root.$emit('showNotification', message, 'success')
    },
    showInformation: function (message) {
      let self = this
      self.$root.$emit('showNotification', message, 'primary')
    },
    showWarning: function (message) {
      let self = this
      self.$root.$emit('showNotification', message, 'warning')
    },
    showError: function (message) {
      let self = this
      self.$root.$emit('showNotification', message, 'danger')
    },
    handleError: function (error) {
      let self = this

      if (error !== undefined && error.response !== undefined && error.response.status === 403) {
        self.$router.push('/login')
      }

      let status = ''
      let data = ''

      if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
        status = error.response.statusText
      }
      if (error !== undefined && error.response !== undefined && error.response.data !== undefined) {
        data = error.response.data
      }

      let errMsg = `There was an error getting data: ${status} ${data}`
      console.log(errMsg)

      self.$root.$emit('showNotification', errMsg)
    },
    showMessage: function (val) {

    },
    IsAlphaNumeric(entry) {
      const regEx = /^[a-z\d\-_\s]+$/i
      if (entry.match(regEx)) {
        return true
      } else {
        return false
      }
  }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/basePageMixin.js